//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginForm from "~/themes/fiskarsMoominDefault/components/components/organisms/LoginForm/LoginForm.vue";
export default {
  name: "MoominLoginForm",
  components: {
    LoginForm
  },
  props: {
    title: {
      type: String,
      default: 'Log in details'
    },
    email: {
      type: String,
      default: 'Email'
    },
    emailplaceholdertext: {
      type: String,
      default: 'Email'
    },
    emailvalidationmessage: {
      type: String,
      default: 'Email error'
    },
    emailformatvalidationmessage: {
      type: String,
      default: 'This is not a valid email'
    },
    password: {
      type: String,
      default: 'Password'
    },
    passwordplaceholdertext: {
      type: String,
      default: 'Password'
    },
    passwordvalidationmessage: {
      type: String,
      default: 'Password error'
    },
    captcha: {
      type: [Object, String],
      default: ''
    },
    buttontext: {
      type: String,
      default: 'Submit'
    },
    forgotpasswordtext: {
      type: String,
    },
    forgotpasswordlink: {
      type: String,
    },
    error: {
      type: Object,
      default: () => ({})
    },
    success: {
      type: Object,
      default: () => ({})
    },
  },
}
